import i18n from 'i18n/i18n';
import * as $ from 'jquery';
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorInfo: "",ok:false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      errorInfo: "" + error.toString()
    })

    // remove mui backdrop for crash
    var interval = setInterval(() => {
      let iframe = $("iframe");
      if (iframe) {
        $("iframe").remove();
      }
      else {
        clearInterval(interval);
      }
    }, 1000);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div style={{ textAlign: "center" }}><h1>😔 {i18n().something_went_wrong} 😔</h1> <pre className='boundaryErrorPre'> {this.state.errorInfo} </pre> <button onClick={() => { window.location.reload() }}>reload page</button></div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;